import { useTranslations } from "adapters/i18n";
import { useMemo } from "react";
import {
  CategoryStatusFilter,
  WeightGainCurveFilter,
} from "../utils/category.utils";

export function useFilterOptions() {
  const { t } = useTranslations();

  const statusOptions = useMemo(
    () => [
      {
        value: CategoryStatusFilter.All,
        label: t("common:all-fem").toUpperCase(),
      },
      {
        value: CategoryStatusFilter.Active,
        label: t("common:status.activated-plural-fem").toUpperCase(),
      },
      {
        value: CategoryStatusFilter.Inactive,
        label: t("common:status.disabled-plural-fem").toUpperCase(),
      },
    ],
    [t]
  );

  const weightGainCurveOptions = useMemo(
    () => [
      {
        value: WeightGainCurveFilter.All,
        label: t("common:all-fem").toUpperCase(),
      },
      {
        value: WeightGainCurveFilter.Yes,
        label: t("common:actions.yes").toUpperCase(),
      },
      {
        value: WeightGainCurveFilter.No,
        label: t("common:actions.no").toUpperCase(),
      },
    ],
    [t]
  );

  return { statusOptions, weightGainCurveOptions };
}
